import { render, staticRenderFns } from "./uploadlist.vue?vue&type=template&id=5b50bac3"
import script from "./uploadlist.vue?vue&type=script&lang=js"
export * from "./uploadlist.vue?vue&type=script&lang=js"
import style0 from "./uploadlist.vue?vue&type=style&index=0&id=5b50bac3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports